module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.c0f1e4a.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Bold.woff2
// module id = 449
// module chunks = 1